import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const baseTokenMan = 'base_token_u'
const baseTokenVal = 'base_token'
const store = new Vuex.Store({
  state() {
    return {
      user: null,
      token: null,
      jsonToken: (JSON.parse(localStorage.getItem('base_token_u')) !== '' && JSON.parse(localStorage.getItem('base_token_u')) !== null ? JSON.parse(localStorage.getItem('base_token_u')).user : ''),
      amapKey: '4a2840b16bfe89cd9d748d771dc7af9f', // 仅支持服务

      url: 'https://qsn-man-ui.ayqsng.cn',
      apiurl: 'https://qsn-man-api.ayqsng.cn',
      fileApiUrl: 'https://qsn-file-api.ayqsng.cn'
      // url: 'http://localhost:9080/Center/Version',
      // apiurl: 'http://localhost:54349',
      // fileApiUrl: 'https://qsn-file-api.sskd.top'
    }
  },
  getters: {
    // 全局token
    getStorage: function (state) {
      if (!state.user) {
        state.user = JSON.parse(localStorage.getItem(baseTokenMan))
      }
      return state.user
    },
    getToken: function (state) {
      if (!state.token) {
        state.token = JSON.parse(localStorage.getItem(baseTokenVal))
      }
      return state.token
    }
  },
  mutations: {
    // 全局token
    $_setStorage(state, value) {
      state.user = value
      localStorage.setItem(baseTokenMan, JSON.stringify(value))
    },
    $_removeStorage(state) {
      state.user = null
      localStorage.removeItem(baseTokenMan)
    },
    $_setToken(state, value) {
      state.token = value
      localStorage.setItem(baseTokenVal, JSON.stringify(value))
    },
    $_removeToken(state) {
      state.token = null
      localStorage.removeItem(baseTokenVal)
    }
  }
})

export default store
